document.addEventListener("DOMContentLoaded", () => {

  /* ==========================
     SEARCH TOGGLE
  ========================== */
  const searchToggle = document.getElementById("SearchToggle");
  const searchPanel = document.querySelector(".waands-search");

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener("click", () => {
      const isHidden = searchPanel.hasAttribute("hidden");
      if (isHidden) {
        searchPanel.removeAttribute("hidden");
        document.body.classList.add("search-open");
        const input = searchPanel.querySelector('input[type="search"]');
        if (input) setTimeout(() => input.focus(), 100);
      } else {
        searchPanel.setAttribute("hidden", "");
        document.body.classList.remove("search-open");
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !searchPanel.hasAttribute("hidden")) {
        searchPanel.setAttribute("hidden", "");
        document.body.classList.remove("search-open");
      }
    });
  }


  /* ==========================
     STICKY HEADER
  ========================== */
  const stickyHeader = document.querySelector(".waands-header.header--sticky");

  if (stickyHeader) {
    let headerHeight = stickyHeader.offsetHeight;
    const recalcHeight = () => { headerHeight = stickyHeader.offsetHeight; };
    window.addEventListener("resize", recalcHeight);
    window.addEventListener("load", recalcHeight);

    window.addEventListener("scroll", () => {
      if (window.scrollY > headerHeight) {
        if (!stickyHeader.classList.contains("is-fixed")) {
          stickyHeader.classList.add("is-fixed");
          document.body.style.paddingTop = headerHeight + "px";
        }
      } else {
        if (stickyHeader.classList.contains("is-fixed")) {
          stickyHeader.classList.remove("is-fixed");
          document.body.style.paddingTop = "";
        }
      }
    });
  }


  /* ==========================
     MEGA MENU (Desktop)
  ========================== */
  let megaMenuTimeout;
  const headerBar = document.querySelector(".waands-header-bar");
  const navItems = document.querySelectorAll(".waands-nav-item");
  let clickOpenedMenu = null;

  function getHeaderBottom() {
    if (headerBar) return headerBar.getBoundingClientRect().bottom;
    const h = document.querySelector(".waands-header");
    return h ? h.getBoundingClientRect().bottom : 60;
  }

  function positionMega(mega) {
    if (!mega) return;
    const headerBottom = getHeaderBottom();
    // We update the top coordinate.
    // Ensure it sits flush with the BOTTOM of the header bar.
    mega.style.top = Math.floor(headerBottom) + 'px';
  }

  function closeMegaMenus() {
    navItems.forEach(item => {
      const link = item.querySelector(".waands-nav-link");
      const mega = item.querySelector(".waands-mega");
      const dropdown = item.querySelector(".waands-dropdown");
      if (mega) mega.classList.remove("is-open");
      if (dropdown) dropdown.classList.remove("is-open");
      if (link) link.classList.remove("is-open");
    });
    clickOpenedMenu = null;
  }

  function openMegaMenu(navItem, isClickOpen) {
    const link = navItem.querySelector(".waands-nav-link");
    const mega = navItem.querySelector(".waands-mega");
    if (!mega) return;

    navItems.forEach(item => {
      if (item !== navItem) {
        const otherLink = item.querySelector(".waands-nav-link");
        const otherMega = item.querySelector(".waands-mega");
        if (otherMega) {
          otherMega.classList.remove("is-open");
          if (otherLink) otherLink.classList.remove("is-open");
        }
      }
    });

    positionMega(mega);
    mega.classList.add("is-open");
    if (link) link.classList.add("is-open");
    clearTimeout(megaMenuTimeout);
    if (isClickOpen) clickOpenedMenu = navItem;
  }

  navItems.forEach(navItem => {
    const link = navItem.querySelector(".waands-nav-link");
    const mega = navItem.querySelector(".waands-mega");
    if (!mega) return;

    // Click toggles mega menu open/closed, prevents page navigation
    if (link) {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        mega.classList.contains("is-open") ? closeMegaMenus() : openMegaMenu(navItem, true);
      });
    }

    // Hover open
    navItem.addEventListener("mouseenter", () => {
      clearTimeout(megaMenuTimeout);
      if (clickOpenedMenu !== navItem) openMegaMenu(navItem, false);
    });

    // Hover close — if cursor is still above the mega menu when leaving the nav item,
    // it may be heading there (mega is full-width so any Y above menu top counts).
    // On small screens this is critical — use a generous timeout in that case.
    navItem.addEventListener("mouseleave", (e) => {
      if (clickOpenedMenu === navItem) return;
      const megaTop = getHeaderBottom();
      const aboveMega = e.clientY < megaTop;
      megaMenuTimeout = setTimeout(closeMegaMenus, aboveMega ? 500 : 100);
    });

    // Keep open while hovering over the mega menu panel
    mega.addEventListener("mouseenter", () => clearTimeout(megaMenuTimeout));
    mega.addEventListener("mouseleave", (e) => {
      if (clickOpenedMenu === navItem) return;
      megaMenuTimeout = setTimeout(closeMegaMenus, 150);
    });
  });

  // Standard dropdown toggle (items without mega, e.g. About)
  // Clicking the nav link toggles the dropdown open/closed without navigating.
  navItems.forEach(navItem => {
    const link = navItem.querySelector(".waands-nav-link");
    const dropdown = navItem.querySelector(".waands-dropdown");
    if (!dropdown || navItem.querySelector(".waands-mega")) return;

    if (link) {
      link.addEventListener("click", e => {
        e.preventDefault();
        const isOpen = dropdown.classList.contains("is-open");
        closeMegaMenus();
        if (!isOpen) {
          dropdown.classList.add("is-open");
          link.classList.add("is-open");
        }
      });
    }
  });

  // Reposition on resize (header height can change with announcement bar etc.)
  window.addEventListener("resize", () => {
    navItems.forEach(item => {
      const mega = item.querySelector(".waands-mega.is-open");
      if (mega) positionMega(mega);
    });
  });

  // Close when clicking outside the header
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".waands-nav-item")) closeMegaMenus();
  });

  // Close on scroll only if menu was click-opened
  document.addEventListener("scroll", () => {
    if (clickOpenedMenu) closeMegaMenus();
  }, { passive: true });


  /* ==========================
     MOBILE MENU
  ========================== */
  const burgerBtn = document.querySelector(".waands-burger");
  const mobileMenu = document.querySelector(".waands-mobile-menu");
  const mobileCloseBtn = document.querySelector(".waands-mobile-close");
  const mobileOverlay = document.querySelector(".waands-mobile-menu-overlay");
  const mobileToggles = document.querySelectorAll(".waands-mobile-menu-toggle");

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove("is-open");
    mobileMenu.setAttribute("hidden", "");
    if (burgerBtn) burgerBtn.setAttribute("aria-expanded", "false");
    mobileToggles.forEach(toggle => {
      toggle.setAttribute("aria-expanded", "false");
      const submenu = document.getElementById(toggle.getAttribute("aria-controls"));
      if (submenu) submenu.setAttribute("hidden", "");
    });
  }

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add("is-open");
    mobileMenu.removeAttribute("hidden");
    if (burgerBtn) burgerBtn.setAttribute("aria-expanded", "true");
  }

  if (mobileMenu && burgerBtn) {
    burgerBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      mobileMenu.classList.contains("is-open") ? closeMobileMenu() : openMobileMenu();
    });

    mobileToggles.forEach(toggle => {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isExpanded = toggle.getAttribute("aria-expanded") === "true";
        const submenu = document.getElementById(toggle.getAttribute("aria-controls"));
        if (!submenu) return;

        // Collapse all other submenus
        mobileToggles.forEach(t => {
          if (t !== toggle) {
            t.setAttribute("aria-expanded", "false");
            const other = document.getElementById(t.getAttribute("aria-controls"));
            if (other) other.setAttribute("hidden", "");
          }
        });

        if (isExpanded) {
          submenu.setAttribute("hidden", "");
          toggle.setAttribute("aria-expanded", "false");
        } else {
          submenu.removeAttribute("hidden");
          toggle.setAttribute("aria-expanded", "true");
        }
      });
    });

    if (mobileOverlay) {
      mobileOverlay.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeMobileMenu();
      });
    }

    if (mobileCloseBtn) {
      mobileCloseBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeMobileMenu();
      });
    }

    // Close when navigating via a direct link
    document.querySelectorAll(".waands-mobile-menu-label-link, .waands-mobile-link").forEach(link => {
      link.addEventListener("click", () => setTimeout(closeMobileMenu, 0));
    });

    // Prevent submenu clicks from bubbling up and closing the menu
    document.querySelectorAll(".waands-mobile-submenu-inner").forEach(inner => {
      inner.addEventListener("click", (e) => e.stopPropagation());
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeMobileMenu();
    });
  }

});
